import * as yup from 'yup';
import { createConditionalValidator } from 'utils/yup';
import { NEW_APARTMENT } from 'constants/constants';
import { getPartOfValidationSchema } from '../../helpers';

const validationSchema = yup.object().shape({
  ...getPartOfValidationSchema({ projectType: NEW_APARTMENT, groupName: 'energy' }),
  new_windows_number: createConditionalValidator('new_windows', 'number'),
});

export default validationSchema;
